<template lang="pug">
.match-bet-area-type
  .match-bet-area-type-title {{ betType == 'oe' ? $tc("m.BT_OEF", 2) : $tc("m.BT_OEH", 2) }}
  .match-odd-area
    .match-odd-area-oddtype
      p.mb-0 {{ $t("m.ODD_Odd") }}
      p.mb-0 {{ $t("m.ODD_Even") }}
    template(v-for="(dn, i) in details['tn']")
      .match-odd-area-group(v-if="i == 0")
        template(v-if="details[betType] && details[betType][i] && details[betType][i][5] != 0 && details[betType][i][5] != ''")
          OddsItem(:odds="details[betType][i]" idx=5 :typ="oddsType" dataType="2")
        template(v-else)
          OddsDisabled
        template(v-if="details[betType] && details[betType][i] && details[betType][i][7] != 0 && details[betType][i][7] != ''")
          OddsItem(:odds="details[betType][i]" idx=7 :typ="oddsType" dataType="2")
        template(v-else)
          OddsDisabled
</template>

<script>
import OddsItem from "@/components/mobile/main/xitem/oddsItem";
import OddsDisabled from "@/components/mobile/main/xitem/oddsDisabled";

export default {
  components: {
    OddsItem,
    OddsDisabled
  },
  props: {
    details: {
      type: Object
    },
    oddsType: {
      type: String
    },
    i: {
      type: [String, Number]
    },
    betType: {
      type: String
    },
    homeAway: {
      type: String
    },
  }
};
</script>